import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'epbt-fa-competitor-price-type-list',
  templateUrl: './epbt-fa-competitor-price-type-list.component.html',
  styleUrls: ['./epbt-fa-competitor-price-type-list.component.scss']
})
export class EpbtFaCompetitorPriceTypeListComponent implements OnInit {
  // default = ['(Standard Price)', 'Addresses'];
  dropDownData = [{
    value: 0, text: "(Standard Price)"
  }, { value: 1, text: "Addresses" }];
  // selectedDefault: string = this.default[0];

  @Output() selectedAddressChange = new EventEmitter<any>();

  private _selectedPriceType: number;
  @Input('selectedPriceType') set selectedPriceType(value: number) {
    this._selectedPriceType = value;
    this.selectedAddressChange.emit(this._selectedPriceType);
  }
  get selectedPriceType(): number {
    return this._selectedPriceType;
  }
  constructor() { }

  ngOnInit() {
    // this.default[0];
  }

  onSelectionChange(selectedValue: any) {
    this.selectedPriceType = selectedValue;
    this.selectedAddressChange.emit(this.selectedPriceType);
  }

}
